module.exports = __webpack_public_path__ + "static/media/MifepristoneTestAnswers.ccbbb221.docx";